import { useContext, useEffect } from 'react';
import { RutinSettingsContext } from '../../Delsystem/_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import OnStartWarningDialog from '../../Delsystem/_Common/Components/OnStartWarningDialog/OnStartWarningDialog';
import { LoginStateContext } from '../../Login/Contexts/LoginStateContext/LoginStateContext';
import { IRutinInfo } from '../../../Types/RutinInfoType';
import { IRoutine } from '../../Delsystem/_Common/Const/Delsystem';

export const withActiveRoutine =
  (routine: IRoutine, rutinInfo: IRutinInfo) => () => {
    const { setActiveRoutine } = useContext(RutinSettingsContext);
    const loginStateContext = useContext(LoginStateContext);
    useEffect(() => {
      setActiveRoutine(rutinInfo.rutinID);
      return setActiveRoutine;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let loading = false;
    let ok = true;
    let warningText = '';
    if (routine.onStartWarningHook != null) {
      ({ loading, ok, warningText } = routine.onStartWarningHook(
        loginStateContext.isLoggedIn
      ));
    }
    return (
      <>
        <routine.component />
        <OnStartWarningDialog
          loading={loading}
          ok={ok}
          warningText={warningText}
          isLoggedIn={loginStateContext.isLoggedIn}
        />
      </>
    );
  };
